import { get, getAll } from '@bigyouth/base'
import { FORM_ACTIONS } from './formValidation'
import { get as getPipe } from '../utils/sigpipe'
import emitter from '../utils/emitter'

export default {
  name: 'catalog',

  ui: {
    'panels[]': '[js-catalog-panel]',
    nextStep: '[js-catalog-next-step]',
    'choices[]': '[js-catalog-choice]',
    'textInputs[]': '[js-catalog-text-input]',
    choiceAll: '[js-catalog-choice-all]',
  },

  events: [
    {
      on: 'click',
      target: 'nextStep',
      handle () {
        this.ui.panels.forEach((panel) => {
          panel.classList.toggle('hidden')
          this.el.closest('.modal__wrapper').scrollTo({ top: 0 })
        })
      },
    },
    {
      on: 'change',
      target: 'choices',
      handle () {
        const choicesChecked = getAll('[js-catalog-choice]:checked')

        this.ui.choiceAll.checked = false
        this.manageNextButton(choicesChecked.length > 0)
      },
    },
    {
      on: 'change',
      target: 'choiceAll',
      handle (e) {
        this.ui.choices.forEach((choice) => {
          choice.checked = false
        })

        this.manageNextButton(e.target.checked)
      },
    },
  ],

  componentDidMount () {
    emitter.on('close_modal', (datas) => {
      if (datas.modal === this.el.closest('.modal').id) {
        this.ui.panels.forEach((panel) => {
          panel.classList.toggle('hidden')
        })

        this.ui.panels[0].classList.remove('hidden')
        this.ui.panels[1].classList.add('hidden')

        this.ui.choices.forEach((choice) => {
          choice.checked = false
        })

        this.ui.textInputs.forEach((input) => {
          input.value = ''
        })

        get('input[name="cgv"]').checked = false

        getAll('.form__field-error', this.el).forEach((error) => {
          error.remove()
        })

        getAll('.has-error', this.el).forEach((error) => {
          error.classList.remove('has-error')
        })

        get('[js-form-validation-submit]').classList.remove('is-loading')
        get('.loader', this.el).remove()

        this.ui.choiceAll.checked = false
        this.ui.nextStep.classList.add('is-disabled')
      }
    })

    setTimeout(() => {
      const formId = this.el.getAttribute('data-form-id')

      if (formId) {
        this.pipe = getPipe(formId)

        if (this.pipe) {
          this.pipe.on(({ action, formData }) => {
            switch (action) {
              case FORM_ACTIONS.SUBMIT: {
                const themes = []

                for (const [key, value] of Object.entries(formData)) {
                  if (key.includes('catalogChoices')) {
                    if (value === 1) {
                      themes.push(key.split('[')[1].split(']')[0])
                    }
                  }
                }
                const loader = document.createElement('div')
                const submitButton = get('[js-form-validation-submit]')
                loader.classList.add('loader')
                submitButton.prepend(loader)
                submitButton.classList.add('is-loading')
                // eslint-disable-next-line no-undef
                _paq.push(['trackEvent', 'Click', 'Catalogue', `telechargement-ok-${themes.join(',')}`])
                setTimeout(() => {
                  const closeButton = this.el.closest('.modal').querySelector('[js-modal-close]')
                  if (closeButton) {
                    closeButton.click()
                  }
                }, 300)
                break
              }
            }
          })
        }
      }
    }, 500)
  },

  manageNextButton (condition) {
    if (condition) {
      this.ui.nextStep.classList.remove('is-disabled')
    } else {
      this.ui.nextStep.classList.add('is-disabled')
    }
  },
}
